import React from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';
import Question from './Question.jsx';
import { Base } from './QuestionGroups';
import QuestionGroupHeader from './QuestionGroupHeader';
import { useQuestionContext } from './QuestionContext.jsx';
import { lowercaseFirstChar } from '../utils';
import { Widget } from './QuestionGroups/layouts/Widget.mjs';
import WidgetRenderer from './QuestionGroups/layouts/WidgetRenderer';

const QuestionGroup = (props) => {
  const {
    GroupComponent = Base,
    page,
    questionGroup,
    validationErrors = [],
  } = props;

  const questionComponents = useQuestionContext();
  const classes = classnames(
    'questionGroup',
    `questionGroup--${lowercaseFirstChar(questionGroup.type)}`,
    `${lowercaseFirstChar(questionGroup.type)}-questionGroup`
  );

  const isWidget = Widget.isRegisteredWidget(questionGroup.type);

  const renderQuestion = (question) => {
    const hasError = validationErrors.find(
      (e) => e.key === question.appkey && (e.shouldDisplay || questionComponents.displayValidationErrors)
    );
    question.errors = hasError ? hasError.errors : undefined;
    const questionProps = {
      appkey: question.appkey,
      page,
      questionGroup,
      question,
    };
    const questionClasses = classnames(
      'question',
      `${lowercaseFirstChar(question.type)}Question`,
      {
        ['question--error']: hasError,
      }
    );
    return (
      <Question
        component={questionComponents.getQuestionComponent(question.type)}
        {...questionProps}
        key={question.appkey}
        className={questionClasses}
      />
    );
  };

  const renderAllQuestions = () => (questionGroup.questions || []).map((q) => renderQuestion(q, page));
  const groupComponentConfig = GroupComponent?.questionGroupConfig || {};
  const renderHeader = Object.prototype.hasOwnProperty.call(
    groupComponentConfig,
    'renderHeader'
  )
    ? groupComponentConfig.renderHeader
    : true;

  if (isWidget) {
    return (
      <WidgetRenderer
        questionGroup={questionGroup}
        page={page}
        validationErrors={validationErrors}
      />
    );
  }

  return (
    <section className={classes} id={questionGroup.key}>
      {renderHeader && <QuestionGroupHeader questionGroup={questionGroup} />}
      <GroupComponent
        page={page}
        questionGroup={questionGroup}
        renderAllQuestions={renderAllQuestions}
        renderQuestion={renderQuestion}
      />
    </section>
  );
};

QuestionGroup.propTypes = {
  page: PropTypes.any.isRequired,
  questionGroup: PropTypes.any.isRequired,
  className: PropTypes.string,
  validationErrors: PropTypes.array,
  GroupComponent: PropTypes.any,
};

export default QuestionGroup;
